<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2024-05-11 10:25:21
 * @LastEditors: whaoo
 * @LastEditTime: 2024-05-14 16:50:29
-->
<template>
  <div class="container">
    <div v-if="!showInner">
      <div class="search_box flex_start_center">
        <div class="flex_start_center mr_12">
          <!-- <div class="mr_12">状态：</div> -->
          <div>
            <el-select v-model="in_hospital" style="width:136px;">
              <el-option label="在院" :value="1"></el-option>
              <el-option label="离院" :value="2"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex_start_center mr_12">
          <!-- <div class="mr_12">状态：</div> -->
          <div>
            <el-select v-model="bind" style="width:136px;">
              <el-option label="全部" :value="0"></el-option>
              <el-option label="绑定中" :value="1"></el-option>
              <el-option label="未绑定" :value="2"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex_start_center mr_12">
          <div class="mr_12">床位号：</div>
          <div>
            <el-input placeholder="请输入床位号" style="width:300px;" v-model="searchForm.bed_number"
              @keyup.enter.native="search"></el-input>
          </div>
        </div>
        <div class="flex_start_center mr_12">
          <div class="mr_12">患者住院号：</div>
          <div>
            <el-input placeholder="请输入患者住院号" style="width:300px;" v-model="searchForm.patient_id"
              @keyup.enter.native="search"></el-input>
          </div>
        </div>
        <!-- <el-button type="primary" @click="search">搜索</el-button> -->
        <div class="custom_btn primary_btn" @click="search">搜索</div>
        <div class="custom_btn warning_btn" @click="reset">重置</div>
        <!-- <el-button type="warning" @click="reset">重置</el-button> -->
      </div>
      <el-table :data="tableData" v-loading="loading" align="center" border>
        <el-table-column prop="name" label="患者姓名" align="center"></el-table-column>
        <el-table-column prop="patient_id" label="住院号" align="center"></el-table-column>
        <el-table-column prop="bed_number" label="床位号" align="center"></el-table-column>
        <el-table-column prop="today_walk" label="今日步数（步）" align="center"></el-table-column>
        <el-table-column prop="yesterday_walk" label="昨日步数（步）" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button plain type="primary" size="large" @click="handleActivityDialog(scope.row)">活动统计</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="block" style="text-align: center;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
          :page-sizes="[10, 15, 20, 25]" :page-size="perPage" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </div>
    <ActivityInner v-else :patientInfo="patientInfo" @handleBackBtn="handleBackBtnFn"></ActivityInner>
    <!-- <ActivityDialog :dialogVisible="showActivityDialog" :dialogData="patientInfo" @closeDialog="closeDialog">
    </ActivityDialog> -->
  </div>
</template>

<script>
// import ActivityDialog from './components/activityDialog.vue';
import ActivityInner from './components/activity_inner.vue';

export default {
  data() {
    return {
      searchForm: {
        bed_number: "",
        patient_id: "",
      },
      page: 1,
      perPage: 10,
      total: 0,
      tableData: [],
      loading: false,
      zone_number: "",
      patientInfo: {},
      showActivityDialog: false,
      in_hospital: 1,
      bind: 1,
      showInner: false
    };
  },
  components: {
    ActivityInner,
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/login");
    }
    this.zone_number = localStorage.getItem("zone_number");
    this.fetchData();
  },

  methods: {
    reset() {
      this.searchForm.bed_number = "";
      this.searchForm.patient_id = "";
      this.bind = 1,
        this.in_hospital = 1
      this.page = 1;
      this.fetchData();
    },
    search() {
      this.page = 1;
      this.fetchData();
    },
    handleSizeChange(e) {
      this.perPage = e;
      this.page = 1;
      this.fetchData();
    },
    handleCurrentChange(e) {
      this.page = e;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      let data = {
        page: this.page,
        perPage: this.perPage,
        zone_number: this.zone_number,
        bed_number: this.searchForm.bed_number,
        patient_id: this.searchForm.patient_id,
        bind: this.bind,
        in_hospital: this.in_hospital
      };
      if (data.bind == "0") {
        delete data.bind;
      }
      this.$http({
        url: "/api/report/activity_list",
        method: "POST",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        const result = res.result;
        this.tableData = result.data;
        this.total = result.total;
        this.loading = false;
      });
    },
    handleActivityDialog(patientInfo) {
      this.patientInfo = patientInfo;
      this.showInner = true;
    },
    handleBackBtnFn() {
      this.showInner = false
    },
    closeDialog() {
      this.showActivityDialog = false;
    }


  },
};
</script>
<style scoped>
@import url('../../assets/style/commo.css');

.custom_title {
  color: #252b50;
  font-size: 24px;
  font-weight: bolder;
  margin-right: 20px;
}

.radiu_chart {
  width: 210px;
  height: 210px;
}

.mb_24 {
  margin-bottom: 24px;
}

.dialog_body {
  width: 100%;
}

.dialog_body_title {
  color: #252b50;
  font-weight: bold;
  font-size: 16px;
}

.legend_item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  padding-left: 32px;
}

.legend_item:nth-child(1) .circle {
  background-color: #cce4fd;
}

.legend_item:nth-child(2) .circle {
  background-color: #80bbfb;
}

.legend_item:nth-child(3) .circle {
  background-color: #0076f6;
}

.legend_item .circle {
  width: 12px;
  height: 12px;
  border-radius: 12px;
  margin-right: 6px;
}

.legend_item .text {
  color: #9296af;
  margin-right: 8px;
}

.legend_item .percent {
  color: #636676;
}

.statics_data {
  padding: 0 110px;
  height: 100px;
  background: #f5f7fb;
  border-radius: 8px;
  color: #9296af;
  text-align: center;
  margin-bottom: 20px;
}

.statics_data_item .num {
  color: #252b50;
  font-size: 32px;
  font-weight: bold;
}

.statics_line {
  width: 1px;
  background-color: #d9d9d9;
  height: 24px;
}

.line {
  width: 12px;
  height: 3px;
  border-radius: 3px;
}

.line_1 {
  background-color: #07c160;
}

.line_2 {
  background-color: #9296af;
}

.legend_2 {
  font-size: 12px;
  color: #9296af;
}

.legend_2 div {
  margin-left: 5px;
}

.line_chart {
  width: 710px;
  height: 300px;
}

.nodata {
  text-align: center;
  padding: 100px 0 200px;
  font-size: 14px;
  color: #929faf;
}

.nodata img {
  width: 162px;
}


.custom_title_box>>>.el-input__inner {
  border: unset !important;
  font-size: 18px !important;
}
</style>


// WEBPACK FOOTER //
// src/view/managePages/activity_statics.vue